module.exports = __webpack_public_path__ + "img/socooc-conditions.f76750b9.png";